
if (!Array.prototype.remove) {
    Array.prototype.remove = function(elementToRemove) {
        var index = this.indexOf(elementToRemove);

        if (index > -1) {
            this.removeIndex(index);
        }
    }
}

if (!Array.prototype.removeIndex) {
    Array.prototype.removeIndex = function (index) {
        if (index < 0 || index > this.length - 1) {
            throw new RangeError("Index " + index.toString() + " is out of range");
        }
        this.splice(index, 1);
    }
}

if (!Array.prototype.contains) {
    Array.prototype.contains = function (item) {
        return this.indexOf(item) != -1;
    }
}

if (!Array.prototype.last) {
    Array.prototype.last = function (item) {
        return this[this.length - 1];
    }
}

if (!Array.prototype.first) {
    Array.prototype.first = function (item) {
        return this[0];
    }
}

if (!Array.prototype.getIndexByProperty) {
    Array.prototype.getIndexByProperty = function (property, value) {
        for (var index = 0; index < this.length; index++) {
            var item = this[index];

            var propertyChain = property.split(".");

            for(var index2 = 0; index2 < propertyChain.length; index2++){
                var chainedProperty = propertyChain[index2];

                if(item === null){
                    break;
                }
                item = item[chainedProperty];
            }

            if (item === value) {
                return index;
            }
        }

        return -1;
    }
}

if (!Array.prototype.getItemByProperty) {
    Array.prototype.getItemByProperty = function (property, value) {
        var index = this.getIndexByProperty(property, value);

        if (index == -1) {
            return null;
        }

        return this[index];
    }
}

if (!Array.prototype.getItemsByProperty) {
    Array.prototype.getItemsByProperty = function (property, value) {
        var index = this.getIndexByProperty(property, value);

        if(index == -1){
            return [];
        }

        var item = this[index];
        var newArray = this.slice(index + 1);

        newArray = newArray.getItemsByProperty(property, value);
        newArray.push(item);

        return newArray;
        // var items = [];

        // for (var index = 0; index < this.length; index++) {
        //     var item = this[index];

        //     if (item[property] === value) {
        //         items.push(item);
        //     }
        // }

        // return items;
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/app/extensions/array.js
// module id = 433
// module chunks = 1